export class TechnicalReviewLogTableRow {
  detailId: string;
  order: number;
  fields: string;
}
